const fetch = require('cross-fetch');
const isString = require('lodash/isString');
const appendQueryParams = require('../utils/append-query-params');

const RestResponse = require('./RestResponse');
const RestResponseError = require('./RestResponseError');

const isJSON = contentType => String(contentType).startsWith('application/json');
const isText = contentType => String(contentType).startsWith('text');
const stringFromBuffer = arrayBuffer => String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));

const defaultOptions = {
  compress: true,
  timeout: 10000,
  headers: {},
  credentials: 'same-origin'
};

/**
 * @private
 * @param {string} url
 * @param {string} method
 * @param {Object} body
 * @param {Object} options
 * @returns {Promise}
 */
const send = (url, method, body, options) => {
  options = {
    ...defaultOptions,
    ...options,
    method,
  };

  if (body) {
    options.body = isString(body) ? body : JSON.stringify(body);
  }

  return fetch(url, options).then(response => {
    const contentType = response.headers.get('content-type');
    const responseHandler = body => {
      if (!response.ok) {
        throw new RestResponseError(response.status, response.statusText, body, response.url);
      }
      return new RestResponse(response.status, contentType, body, response.headers, response.url);
    };

    if (isText(contentType)) {
      return response.text().then(responseHandler);
    }
    if (isJSON(contentType)) {
      return response.json().then(responseHandler);
    }
    return response.arrayBuffer().then(arrayBuff => responseHandler(stringFromBuffer(arrayBuff)));
  });
};

const get = (url, query = {}, options = {}) => {
  return send(appendQueryParams(query, url), 'GET', null, options);
};

const post = (url, body = {}, options = {}) => {
  return send(url, 'POST', body, options);
};

const put = (url, body = {}, options = {}) => {
  return send(url, 'PUT', body, options);
};

const patch = (url, body = {}, options = {}) => {
  return send(url, 'PATCH', body, options);
};

const del = (url, body = {}, options = {}) => {
  return send(url, 'DELETE', body, options);
};

module.exports = {
  request: {
    get,
    post,
    put,
    patch,
    del,
  },
  contentType: {
    isJSON,
    isText,
  },
};



// WEBPACK FOOTER //
// ./src/common/rest/index.js